import React, { FunctionComponent, useEffect } from "react";
import { useNavigate } from "react-router";
import { Table } from "react-bootstrap";

import { useAuthentication } from "../../hooks/useAuthentication";
import { ContentLayout } from "../common/Layout";
import { useAccessibleUsersIds } from "../../hooks/useAccessibleUsersIds";
import { useAuthUser } from "../../hooks/useAuthUser";
import { UserEntryRow } from "./UserEntryRow";

interface Props {
  isAuthenticated: boolean;
}

const UserManagement: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const { user: firebaseAuthUser } = useAuthUser();
  const { userIds, isLoading: isAccessibleUsersLoading } = useAccessibleUsersIds(firebaseAuthUser?.uid);

  useAuthentication(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  if (!firebaseAuthUser) {
    return <></>;
  }

  return (
    <ContentLayout
      title="Benutzer & Formulare"
      siteTitle="Spielgruppe Online - Benutzer"
      subtitle={`${userIds.length + 1} Formulare`}
      isLoading={isAccessibleUsersLoading}>
      <p className="page-intro">
        Hier sehen Sie alle Benutzer, auf deren Formulare & Anmeldungen Sie zugreifen können. Klicken Sie auf einen
        Eintrag, um die entsprechende Umgebung des jeweiligen Benutzers anzuzeigen. Wenn Sie einen Benutzer als Standard
        festlegen, wird diese Umgebung automatisch nach dem Login geladen.
      </p>
      <section className="panel">
        <Table hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>E-Mail</th>
              <th>Standard-Formular</th>
            </tr>
          </thead>
          <tbody>
            <UserEntryRow highlighted={true} userId={firebaseAuthUser.uid} />
            {userIds
              .filter((id) => !!id)
              .filter((id) => id !== firebaseAuthUser.uid)
              .map((userId) => (
                <UserEntryRow key={userId} userId={userId} />
              ))}
          </tbody>
        </Table>
      </section>
    </ContentLayout>
  );
};

export default UserManagement;
